import { UnitType } from "use-smart-locks-shared";

export const containsOnlyParkingLots = (unitTypes: UnitType[]): boolean =>
  unitTypes.length > 0 &&
  unitTypes.every((unitType) => unitType === "parking-lot");
